// extracted by mini-css-extract-plugin
export var orderSummary = "_r3-0";
export var showMoreLessButton = "_r3-1";